import React, { createContext, useContext, useMemo, useState } from "react";
import { UI_STRINGS, LANGS } from "../mock";
import { UI_TRANSLATIONS } from "./uiTranslations";

const I18nContext = createContext(null);

const STORAGE_KEY = "rit_lang";

export const I18nProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem(STORAGE_KEY) || "en");

  const changeLang = (code) => {
    localStorage.setItem(STORAGE_KEY, code);
    setLang(code);
  };

  // Static, pre-written translations — instant and 100% reliable, no network
  // call or external service needed. Falls back to English for any key not
  // yet translated in a given language.
  const dict = useMemo(() => {
    if (lang === "en") return UI_STRINGS;
    return { ...UI_STRINGS, ...(UI_TRANSLATIONS[lang] || {}) };
  }, [lang]);

  const t = (key) => dict[key] || UI_STRINGS[key] || key;

  const value = useMemo(() => ({ lang, setLang: changeLang, t, loading: false, LANGS }), [lang, dict]);
  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
};

export const useI18n = () => {
  const ctx = useContext(I18nContext);
  if (!ctx) throw new Error("useI18n must be used inside I18nProvider");
  return ctx;
};
